import {
  ROLE_NAME_ALIASES,
  USER_ROLE_NAMES,
} from "constants/userRoles";

/**
 * Map invite/signup labels to canonical role names expected by POST /register.
 */
export function normalizeRoleName(roleName?: string | null): string | null {
  if (!roleName?.trim()) {
    return null;
  }
  const trimmed = roleName.trim();
  const alias = ROLE_NAME_ALIASES[trimmed.toLowerCase()];
  if (alias) {
    return alias;
  }
  const match = USER_ROLE_NAMES.find(
    (name) => name.toLowerCase() === trimmed.toLowerCase(),
  );
  return match ?? trimmed;
}

export function isInternalRole(roleName?: string | null): boolean {
  return normalizeRoleName(roleName) === "Internal";
}
